"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WebLogger_1 = require("./web-logger/WebLogger");
var platform_logger_1 = require("./platform-logger/platform-logger");
var SSRLogger_1 = require("./ssr-logger/SSRLogger");
var bi_logger_const_1 = require("./bi-logger.const");
var BiLoggerAdapterBuilder = /** @class */ (function () {
    function BiLoggerAdapterBuilder() {
    }
    BiLoggerAdapterBuilder.prototype.withLogger = function (_a) {
        var _b = _a.biLoggerDefaultConfigurations, biLoggerDefaultConfigurations = _b === void 0 ? null : _b, _c = _a.biLoggerEndPoint, biLoggerEndPoint = _c === void 0 ? bi_logger_const_1.BI_BOOKINGS_USER_OF_USER_END_POINT : _c, wixSdkAdapter = _a.wixSdkAdapter, _d = _a.experiments, experiments = _d === void 0 ? {} : _d;
        if (experiments['specs.BookingsNewFedopsIntegretionSpecs'] === 'true' &&
            !wixSdkAdapter.isRunningInIframe()) {
            var platformAPIs = wixSdkAdapter.getPlatformAPIs();
            this.logger = new platform_logger_1.PlatformLogger({
                platformAPIs: platformAPIs,
                biLoggerDefaultConfigurations: biLoggerDefaultConfigurations,
                biLoggerEndPoint: biLoggerEndPoint,
            });
        }
        else {
            this.logger = new WebLogger_1.WebLogger({
                biLoggerEndPoint: biLoggerEndPoint,
                biLoggerDefaults: biLoggerDefaultConfigurations,
            });
        }
        return this;
    };
    BiLoggerAdapterBuilder.prototype.withWebLogger = function (_a) {
        var _b = _a.biLoggerDefaults, biLoggerDefaults = _b === void 0 ? null : _b, _c = _a.Wix, Wix = _c === void 0 ? window.Wix : _c, _d = _a.biLoggerEndPoint, biLoggerEndPoint = _d === void 0 ? bi_logger_const_1.BI_BOOKINGS_USER_OF_USER_END_POINT : _d;
        this.logger = new WebLogger_1.WebLogger({
            biLoggerDefaults: biLoggerDefaults,
            biLoggerEndPoint: biLoggerEndPoint,
            Wix: Wix,
        });
        return this;
    };
    BiLoggerAdapterBuilder.prototype.setSSRMode = function () {
        this.logger = new SSRLogger_1.SSRLogger();
        return this;
    };
    BiLoggerAdapterBuilder.prototype.build = function () {
        return this.logger;
    };
    return BiLoggerAdapterBuilder;
}());
exports.BiLoggerAdapterBuilder = BiLoggerAdapterBuilder;
var BiLoggerAdapter = /** @class */ (function () {
    function BiLoggerAdapter(_a) {
        var biLoggerDefaultConfigurations = _a.biLoggerDefaultConfigurations, biLoggerEndPoint = _a.biLoggerEndPoint, wixSdkAdapter = _a.wixSdkAdapter, _b = _a.experiments, experiments = _b === void 0 ? {} : _b;
        var isSSR = wixSdkAdapter.isSSR();
        if (isSSR) {
            this.logger = new BiLoggerAdapterBuilder().setSSRMode().build();
        }
        else {
            this.logger = new BiLoggerAdapterBuilder()
                .withLogger({
                biLoggerDefaultConfigurations: biLoggerDefaultConfigurations,
                biLoggerEndPoint: biLoggerEndPoint,
                wixSdkAdapter: wixSdkAdapter,
                experiments: experiments,
            })
                .build();
        }
    }
    BiLoggerAdapter.prototype.log = function (logData) {
        return this.logger.log(logData);
    };
    return BiLoggerAdapter;
}());
exports.BiLoggerAdapter = BiLoggerAdapter;
//# sourceMappingURL=bi-logger-adapter.js.map